import React, { useEffect, useState } from 'react';

import Autocomplete from '@material-ui/lab/Autocomplete';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsFindBy, wsGetAll } from 'services/WService';
import { TextField } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';
import moment from 'moment';

const states = [
  { key: 'A', label: 'Activo' },
  { key: 'I', label: 'Inactivo' }
];

export default WithApp(function FilterArticle(props) {
  const [providers, setProviders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [families, setFamilies] = useState([]);
  const [marks, setMarks] = useState([]);
  const [articles, setArticles] = useState([]);
  const [priceLists, setPriceLists] = useState([]);
  const [zones, setZones] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [canals, setCanals] = useState([]);
  const [sellers, setSellers] = useState([]);

  const [providerId, setProviderId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [familyId, setFamilyId] = useState(null);
  const [markId, setMarkId] = useState(null);

  //#region listados
  async function listProviders() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setProviders(response.data);
  }

  async function listCategories(providerId) {
    let response = await wsFindBy('logi/category', 'base_business_partner_id', providerId);
    if (response.success) setCategories(response.data);
  }

  async function listFamilies(categoryId) {
    let response = await wsFindBy('logi/family', 'logi_category_id', categoryId);
    if (response.success) setFamilies(response.data);
  }

  async function listMarks() {
    let response = await wsGetAll('logi/mark');
    if (response.success) setMarks(response.data);
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listPriceLists() {
    let response = await wsGetAll('logi/price-list');
    if (response.success) setPriceLists(response.data);
  }

  async function listWarehouses() {
    let response = await wsFindBy('logi/warehouse', 'warehouse_type', 'N');
    if (response.success) {
      response.data.unshift({ id: 0, WhsName: 'TODOS LOS ALMACENES' });
      setWarehouses(response.data);
    }
  }

  async function listBureaus() {
    let response = await wsGetAll('base/bureau');
    if (response.success) setBureaus(response.data);
  }

  async function listCanals() {
    let response = await wsGetAll('base/canal');
    if (response.success) setCanals(response.data);
  }

  async function listSellers() {
    let response = await wsGetAll('base/seller');
    if (response.success) setSellers(response.data);
  }

  //#endregion

  function validFilter(valueSearch) {
    if (props.period === undefined) {
      delete valueSearch.period;
    }

    for (let clave in valueSearch) {
      if (valueSearch[clave] == null) {
        delete valueSearch[clave]; //eliminamos las claves nulas
      }
    }
    if (Object.keys(valueSearch).length > 0) {
      if (!!props.setValueSearch) {
        props.setValueSearch(valueSearch);
      }
      if (!!props.article || !!props.getArticleFiltereds) {
        listArticles(valueSearch);
      }
      if (!!props.getFilter) {
        props.getFilter(valueSearch);
      }
    } else {
      if (!!props.getFilter) {
        props.getFilter();
      }
    }
  }

  async function listArticles(valueSearch) {
    let response = await wsFindBy(
      !!props.entity ? props.entity : 'logi/product',
      !!props.paramFilter ? { ...valueSearch, ...props.paramFilter } : valueSearch
    );
    if (response.success) {
      setArticles(response.data);
      if (!!props.getArticleFiltereds) {
        props.getArticleFiltereds(response.data);
      }
    }
  }

  const [valueSearch, setValueSearch] = useState({
    period: moment().format('YYYY-MM')
  });

  useEffect(() => {
    listProviders();
    if (!!props.mark) {
      listMarks();
    }
    if (!!props.priceList) {
      listPriceLists();
    }
    if (!!props.warehouse) {
      listWarehouses();
    }
    if (!!props.zone) {
      listZones();
    }
    if (!!props.bureau) {
      listBureaus();
    }
    if (!!props.canal) {
      listCanals();
    }
    if (!!props.seller) {
      listSellers();
    }
  }, []);

  useEffect(() => {
    validFilter(valueSearch);
  }, [valueSearch]);

  useEffect(() => {
    if (props.productFilter === undefined) return;
    if (!!props.productFilter.base_business_partner_id) {
      setProviderId(props.productFilter.base_business_partner_id);
      listCategories(props.productFilter.base_business_partner_id);
      setValueSearch((value) => ({
        ...value,
        base_business_partner_id: props.productFilter.base_business_partner_id,
      }));
    }
    if (!!props.productFilter.combo_type) {
      setValueSearch((value) => ({
        ...value,
        combo_type: props.productFilter.combo_type,
      }));
    }
  }, [props.productFilter]);

  return (
    <GridContainer>
      {!!props.period ? (
        <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
          <TextField
            label="Periodo"
            fullWidth
            type="month"
            margin="normal"
            value={valueSearch.period || moment().format('YYYY-MM')}
            onChange={(e) => {
              return setValueSearch({
                ...valueSearch,
                period: e.target.value
              });
            }}
            InputLabelProps={{
              shrink: true
            }}
            required={!!props.reqField ? props.reqField.includes('period') : false}
          />
        </GridItem>
      ) : undefined}

      <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
        <Autocomplete
          value={providers.find(provider => provider.id == providerId) || {}}
          options={providers}
          getOptionLabel={(option) => option.CardName || ''}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Proveedor"
              margin="normal"
              required={!!props.reqField ? props.reqField.includes('provider') : false}
            />
          )}
          onChange={(e, item) => {
            if (!!item) {
              setProviderId(item.id);
              listCategories(item.id);
              if (!!props.setNameArticle) {
                props.setNameArticle('');
              }
              if (!!props.setArticleId) {
                props.setArticleId(null);
              }
              delete valueSearch.logi_category_id;
              delete valueSearch.logi_family_id;
              delete valueSearch.logi_product_id;
              setValueSearch({
                ...valueSearch,
                base_business_partner_id: item.id
              });
            } else {
              setProviderId(null);
              setCategoryId(null);
              setFamilyId(null);
              setArticles([]);
              if (!!props.setNameArticle) {
                props.setNameArticle('');
              }
              if (!!props.setArticleId) {
                props.setArticleId(null);
              }
              setValueSearch({
                ...valueSearch,
                base_business_partner_id: null,
                logi_category_id: null,
                logi_family_id: null,
                logi_product_id: null
              });
            }
          }}
        />
      </GridItem>

      <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
        <Autocomplete
          key={providerId}
          options={categories}
          getOptionLabel={(option) => option.description}
          disabled={!valueSearch.base_business_partner_id}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Categoría"
              margin="normal"
              required={!!props.reqField ? props.reqField.includes('category') : false}
            />
          )}
          onChange={(e, item) => {
            if (!!item) {
              listFamilies(item.id);
              setCategoryId(item.id);
              delete valueSearch.logi_family_id;
              delete valueSearch.logi_product_id;
              setValueSearch({
                ...valueSearch,
                logi_category_id: item.id
              });
            } else {
              setCategoryId(null);
              setFamilyId(null);
              setValueSearch({
                ...valueSearch,
                logi_category_id: null,
                logi_family_id: null,
                logi_product_id: null
              });
            }
          }}
        />
      </GridItem>

      <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
        <Autocomplete
          key={providerId + categoryId}
          options={families}
          getOptionLabel={(option) => option.description}
          disabled={!valueSearch.logi_category_id}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Familia"
              margin="normal"
              required={!!props.reqField ? props.reqField.includes('family') : false}
            />
          )}
          onChange={(e, item) => {
            if (!!item) {
              setFamilyId(item.id);
              delete valueSearch.logi_product_id;
              setValueSearch({
                ...valueSearch,
                logi_family_id: item.id
              });
            } else {
              setFamilyId(null);
              setValueSearch({
                ...valueSearch,
                logi_family_id: null,
                logi_product_id: null
              });
            }
          }}
        />
      </GridItem>

      {!!props.mark ? (
        <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
          <Autocomplete
            options={marks}
            getOptionLabel={(option) => option.description}
            defaultValue={null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Marca"
                margin="normal"
                required={!!props.reqField ? props.reqField.includes('mark') : false}
              />
            )}
            onChange={(e, item) => {
              if (!!item) {
                setMarkId(item.id);
                setValueSearch({
                  ...valueSearch,
                  logi_mark_id: item.id
                });
              } else {
                setMarkId(null);
                setArticles([]);
                setValueSearch({
                  ...valueSearch,
                  logi_mark_id: null,
                  logi_product_id: null
                });
              }
            }}
          />
        </GridItem>
      ) : undefined}

      {!!props.article ? (
        <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
          <Autocomplete
            key={providerId + categoryId + familyId + markId}
            options={articles}
            getOptionLabel={(option) => option.ItemName}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Producto"
                margin="normal"
                required={!!props.reqField ? props.reqField.includes('product') : false}
              />
            )}
            onChange={(e, item) => {
              if (!!item) {
                if (!!props.setNameArticle) {
                  props.setNameArticle(item.ItemName);
                }
                if (!!props.setDataChanging) {
                  props.setDataChanging({
                    ...props.dataChanging,
                    logi_product_id: item.id
                  });
                }
                if (!!props.getArticle) {
                  props.getArticle(item);
                }
                setValueSearch({
                  ...valueSearch,
                  logi_product_id: item.id
                });
              } else {
                if (!!props.setNameArticle) {
                  props.setNameArticle('');
                }
                if (!!props.setArticleId) {
                  props.setArticleId(null);
                }
                setValueSearch({
                  ...valueSearch,
                  logi_product_id: null
                });
              }
            }}
          />
        </GridItem>
      ) : undefined}

      {!!props.priceList ? (
        <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
          <Autocomplete
            options={priceLists}
            getOptionLabel={(option) => option.ListName}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Lista de Precios"
                margin="normal"
                required={!!props.reqField ? props.reqField.includes('price-list') : false}
              />
            )}
            onChange={(e, item) => {
              if (!!item) {
                return setValueSearch({
                  ...valueSearch,
                  logi_price_list_id: item.id
                });
              }
              setValueSearch({
                ...valueSearch,
                logi_price_list_id: null
              });
            }}
          />
        </GridItem>
      ) : undefined}

      {!!props.warehouse ? (
        <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
          <Autocomplete
            options={warehouses}
            getOptionLabel={(option) => option.WhsName}
            defaultValue={null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Almacén"
                margin="normal"
                required={!!props.reqField ? props.reqField.includes('warehouse') : false}
              />
            )}
            onChange={(e, item) => {
              if (!!item) {
                return setValueSearch({
                  ...valueSearch,
                  logi_warehouse_id: item.id
                });
              }
              setValueSearch({
                ...valueSearch,
                logi_warehouse_id: null
              });
            }}
          />
        </GridItem>
      ) : undefined}

      {!!props.zone ? (
        <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
          <Autocomplete
            options={zones}
            getOptionLabel={(option) => option.description}
            defaultValue={null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Zona"
                margin="normal"
                required={!!props.reqField ? props.reqField.includes('zone') : false}
              />
            )}
            onChange={(e, item) => {
              if (!!item) {
                return setValueSearch({
                  ...valueSearch,
                  base_zone_id: item.id
                });
              }
              setValueSearch({
                ...valueSearch,
                base_zone_id: null
              });
            }}
          />
        </GridItem>
      ) : undefined}

      {!!props.bureau ? (
        <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
          <Autocomplete
            options={bureaus}
            getOptionLabel={(option) => option.description}
            defaultValue={null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Mesa"
                margin="normal"
                required={!!props.reqField ? props.reqField.includes('bureau') : false}
              />
            )}
            onChange={(e, item) => {
              if (!!item) {
                return setValueSearch({
                  ...valueSearch,
                  base_bureau_id: item.id
                });
              }
              setValueSearch({
                ...valueSearch,
                base_bureau_id: null
              });
            }}
          />
        </GridItem>
      ) : undefined}

      {!!props.canal ? (
        <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
          <Autocomplete
            options={canals}
            getOptionLabel={(option) => option.description}
            defaultValue={null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Canal"
                margin="normal"
                required={!!props.reqField ? props.reqField.includes('canal') : false}
              />
            )}
            onChange={(e, item) => {
              if (!!item) {
                return setValueSearch({
                  ...valueSearch,
                  base_canal_id: item.id
                });
              }
              setValueSearch({
                ...valueSearch,
                base_canal_id: null
              });
            }}
          />
        </GridItem>
      ) : undefined}

      {!!props.seller ? (
        <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
          <Autocomplete
            options={sellers}
            getOptionLabel={(option) => option.SlpName}
            defaultValue={null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Vendedor"
                margin="normal"
                required={!!props.reqField ? props.reqField.includes('seller') : false}
              />
            )}
            onChange={(e, item) => {
              if (!!item) {
                return setValueSearch({
                  ...valueSearch,
                  base_seller_id: item.id
                });
              }
              setValueSearch({
                ...valueSearch,
                base_seller_id: null
              });
            }}
          />
        </GridItem>
      ) : undefined}

      {!!props.state ? (
        <GridItem md={props.fullWidth ? 12 : 2} xs={12}>
          <Autocomplete
            options={states}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Estado"
                margin="normal"
                required={!!props.reqField ? props.reqField.includes('state') : false}
              />
            )}
            onChange={(e, item) => {
              if (!!item) {
                return setValueSearch({ ...valueSearch, state: item.key });
              }
              setValueSearch({ ...valueSearch, state: null });
            }}
          />
        </GridItem>
      ) : undefined}

      {props.children}
    </GridContainer>
  );
});
